import { render, staticRenderFns } from "./Strut1000-H.vue?vue&type=template&id=734a5068"
import script from "./Strut1000-H.vue?vue&type=script&lang=js"
export * from "./Strut1000-H.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports